import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Nav, Row, Tab } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// layout 
import AppLayout from '../../layouts/AppLayout/AppLayout';

// components
import { NioSection, NioBadge, NioCount, NioButton, NioCard, NioMedia, NioIcon, NioField  } from '../../components';

// section content 
import NioSubscribeField from '../../components/Forms/NioSubscribeField/NioSubscribeField';

import FaqContent from '../../components/PageComponents/Homepages/BusinessDigital/FaqContent/FaqContent';
import PricingContent from '../../components/PageComponents/Homepages/BusinessDigital/PricingContent/PricingContent';
import FeaturesContent from '../../components/PageComponents/Homepages/BusinessDigital/FeaturesContent/FeaturesContent';
import TestimonialContent from '../../components/PageComponents/Homepages/BusinessDigital/TestimonialContent/TestimonialContent';
import BASE_URL from '../../utils/apiConfig';

function Index() {
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [authToken, setAuthToken] = useState(null);

    // Authenticate and retrieve the token
    const authenticateUser = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/api_login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: 'api@gmail.com',
                    password: '123',
                }),
            });

            const data = await response.json();
            if (response.ok) {
                setAuthToken(data.access_token);
            } else {
                console.error('Authentication failed:', data.message);
            }
        } catch (error) {
            console.error('Error during authentication:', error);
        }
    };

    // Fetch subscription plans from the API
    const fetchPlans = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/plans`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            const data = await response.json();
            if (response.ok) {
              if (Array.isArray(data.data)) {
                setPlans(data.data); // Set plans if the data is an array
              } else {
                console.error('Plans data is not an array');
              }
            } else {
                console.error('Failed to fetch plans:', data.message);
                toast.error(`Failed to fetch plans: ${data.message}`);
            }
        } catch (error) {
            console.error('Error fetching plans:', error);
            toast.error('An error occurred while fetching subscription plans.');
        } finally {
            setIsLoading(false);
        }
    };

    // UseEffect to handle authentication and data fetching
    useEffect(() => {
        const initialize = async () => {
            await authenticateUser();
        };
        initialize();
    }, []);

    useEffect(() => {
        if (authToken) {
            fetchPlans();
        }
    }, [authToken]);

  return (
    <AppLayout title="Home" layoutClass="5">

      {/*  Banner Section Start  */}
      <section className="nl-banner nl-banner-live-chat-app">
        <div className="nl-banner-wrap" style={{ paddingTop: "120px" }}>
          <Container>
            <Row className="align-items-center justify-content-center justify-content-xl-between pb-xxl-8">
              <Col md="10" xl="5">
                <div className="nl-banner-content text-center text-xl-start pb-5 pb-md-7 pb-xl-0">
                  {/* <ul className="nl-list-link horizontal justify-content-center justify-content-xl-start separator mb-3">
                    <li>
                      <span className="fs-8 fw-bold text-uppercase text-primary">Orders</span>
                    </li>
                    <li>
                      <span className="fs-8 fw-bold text-uppercase text-primary">Leads</span>
                    </li>
                    <li>
                      <span className="fs-8 fw-bold text-uppercase text-primary">Finance & Alot More</span>
                    </li>
                  </ul> */}
                  <div className="pb-5 pb-xl-7">
                    <h1 className="text-capitalize display-3 mb-2" >
                      <span className="title-shape title-shape-3">Transform WhatsApp into Your </span> Sales Powerhouse<span className="ps-1 text-primary">.</span>
                    </h1>
                    <p className="fs-5" >Unlock the Full Potential of Every Chat.</p>
                  </div>
                  {/* <NioSubscribeField  btnText="Sign Up Free" /> */}
                  <ul className="nl-list-link d-flex flex-wrap align-items-center align-items-xl-start justify-content-center justify-content-xl-start flex-xl-column gap-3  py-5 py-xl-7">
                    <li className="p-0" >
                      <NioIcon name="check-circle" className="me-1 text-dark" />
                      <span className="fs-7 text-dark">24/7 Chat Replies</span>
                    </li>
                    <li className="p-0" >
                      <NioIcon name="check-circle" className="me-1 text-dark" />
                      <span className="fs-7 text-dark">Supports English, Sinhala & Tamil</span>
                    </li>
                    <li className="p-0" >
                      <NioIcon name="check-circle" className="me-1 text-dark" />
                      <span className="fs-7 text-dark">Built in All-In-One CRM</span>
                    </li>
                  </ul>
                  {/* <div className="nl-banner-brands">
                    <h6 className="fs-8 mb-5 mb-xl-3 fw-normal text-gray-700 text-capitalize">Trusted by <span className="fw-bold text-dark">Businesses</span> Like Yours </h6>
                    <Row className="justify-content-center justify-content-xl-start gap-5 gap-xl-0">
                      <Col xs="4" sm="3" lg="3" >
                        <div className="nl-brand">
                          <Link to="#">
                            <img src="images/brands/a.png" alt="brand" />
                          </Link>
                        </div>
                      </Col>
                      <Col xs="4" sm="3" lg="3" >
                        <div className="nl-brand">
                          <Link to="#">
                            <img src="images/brands/b.png" alt="brand" />
                          </Link>
                        </div>
                      </Col>
                      <Col xs="4" sm="3" lg="3" >
                        <div className="nl-brand">
                          <Link to="#">
                            <img src="images/brands/c.png" alt="brand" />
                          </Link>
                        </div>
                      </Col>
                      <Col xs="4" sm="3" lg="3" >
                        <div className="nl-brand">
                          <Link to="#">
                            <img src="images/brands/d.png" alt="brand" />
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </div> */}
                </div>
              </Col>
              <Col lg="5" xl="6">
                <div className="nl-banner-img">
                  <img src="images/chat-app/banner-cover.png" alt="banner-cover" />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/*  Banner Section End  */}

      {/*  Feature Section Start   */}
      <NioSection className="nl-feature-section pb-7 pb-lg-120">
      <Row className="justify-content-center">
          <Col lg="10" xl="9"  xxl="8">
            <div className="nl-section-head text-center">
            <span className="nl-section-subtitle mb-2">Powerful Features</span>
            <h2 className="nl-section-title">Why Choose ZiloChat?</h2>
            <p className="mb-0"> 24/7 Availability: ZiloChat keeps WhatsApp active at all times, responding to messages whenever you receive them. </p>
            <ul className="d-flex gap-3 flex-wrap align-items-center justify-content-center pt-5">
              <li>
                <NioButton href="/pricing" className="btn-primary" label="Get Started" />
              </li>
              {/* <li>
                <NioButton href="/contact-us" className="btn-outline-primary" label="Contact Us" />
              </li> */}
            </ul>
            </div>                                    
          </Col>
      </Row>
      <NioSection.Content>
          <Row className="gap g-5">
            <Col sm="6" lg="4">
              <div className="text-center">
                {/* Wrap image in a container with fixed height */}
                <div className="mb-3 mb-md-5" style={{ height: '250px', overflow: 'hidden' }}>
                  <img
                    src="images/business-tracker/section-cover-1.png"
                    alt="cover"
                    className="img-fluid"
                    style={{ width: '100%', height: '100%' }}
                  />
                </div>
                <div className="mb-3">
                  <h4 className="text-capitalize">Automated Interactions</h4>
                  <p className="fs-7 line-clamp-2 fw-medium">
                    Automatically starts conversations, handles inquiries, and follows up with customers.
                  </p>
                </div>
                {/* <NioButton href="" className="btn-link" label="learn More" icon="arrow-right after" /> */}
              </div>
            </Col>
            <Col sm="6" lg="4">
              <div className="text-center">
                <div className="mb-3 mb-md-5" style={{ height: '250px', overflow: 'hidden' }}>
                  <img
                    src="images/business-tracker/section-cover-1-a.png"
                    alt="cover"
                    className="img-fluid"
                    style={{ width: '100%', height: '100%' }}
                  />
                </div>
                <div className="mb-3">
                  <h4 className="text-capitalize">Unmatched Lead Attention</h4>
                  <p className="fs-7 line-clamp-2 fw-medium">
                    We miss nothing, All your chats are handled and labeled by ZiloChat based on their sales stage up until confirmation.
                  </p>
                </div>
                {/* Optionally add the button here */}
              </div>
            </Col>
            <Col sm="6" lg="4">
              <div className="text-center">
                <div className="mb-3 mb-md-5" style={{ height: '250px', overflow: 'hidden' }}>
                  <img
                    src="images/business-tracker/section-cover-1-b.png"
                    alt="cover"
                    className="img-fluid"
                    style={{ width: '100%', height: '100%' }}
                  />
                </div>
                <div className="mb-3">
                  <h4 className="text-capitalize">Personalized Communication</h4>
                  <p className="fs-7 line-clamp-2 fw-medium">
                    Enhances conversations for greater relevance to each customer's needs.
                  </p>
                </div>
                {/* Optionally add the button here */}
              </div>
            </Col>
          </Row>
        </NioSection.Content>

        {/* <NioSection.Content>
          <Row className="gap g-5">
            <Col sm="6" lg="4" >
              <div className="text-center">
                <div className="mb-3 mb-md-5">
                  <img src="images/business-tracker/section-cover-1.png" alt="cover" />
                </div>
                <div className="mb-3">
                  <h4 className="text-capitalize">Automated Interactions</h4>
                  <p className="fs-7 line-clamp-2 fw-medium">Automatically starts conversations, handles inquiries, and follows up with customers.</p>
                </div>
                <NioButton href="" className="btn-link" label="learn More" icon="arrow-right after" />
              </div>
            </Col>
            <Col sm="6" lg="4" >
              <div className="text-center">
                <div className="mb-3 mb-md-5">
                  <img src="images/business-tracker/section-cover-1-a.png" alt="cover" />
                </div>
                <div className="mb-3">
                  <h4 className="text-capitalize">Unmatched Lead Attention</h4>
                  <p className="fs-7 line-clamp-2 fw-medium">We miss nothing, All your chats are handled and labeled by ZiloChat based on their sales stage up until confirmation.</p>
                </div>
                
              </div>
            </Col>
            <Col sm="6" lg="4" >
              <div className="text-center">
                <div className="mb-3 mb-md-5">
                  <img src="images/business-tracker/section-cover-1-b.png" alt="cover" />
                </div>
                <div className="mb-3">
                  <h4 className="text-capitalize">Personalized Communication</h4>
                  <p className="fs-7 line-clamp-2 fw-medium">Enhances conversations for greater relevance to each customer's needs.</p>
                </div>
                
              </div>
            </Col>
          </Row>
          
        </NioSection.Content> */}
      </NioSection>
      {/*  Feature Section End   */}

      

      {/*  Feature Section Start  */}
      <NioSection masks={["blur-1 left top", "blur-1 right bottom"]}>
        <NioSection.Head alignX="center">
          <span className="nl-section-subtitle mb-2">Even More Features</span>
          <h2 className="nl-section-title">To Elevate Your Business</h2>
          <p className="mb-0"></p>
        </NioSection.Head>
        <NioSection.Content>
          <Row className="gy-5">
            <Col lg="6" >
              <NioCard className="border-0 h-100 bg-primary-soft">
                <NioCard.Body>
                  <div className="nl-feature-block-content">
                    <NioMedia size="lg" variant="primary" rounded="circle" icon="pie-2-fill" className="mb-3 mb-lg-5" style={{ "--nl-media-bg-color": "#2A9D8F" }}/>
                    <h4>Turbocharge Your Sales</h4>
                    <p className="fs-7 mb-0">Experience a significant boost in your conversation rates. With ZiloChat, your WhatsApp becomes more than just a messaging app—it's a conversion tool that outperforms traditional websites.</p>
                    <NioButton href="" icon="arrow-right after" className="btn-link mt-2 mt-md-5" label="Learn More" />
                  </div>
                </NioCard.Body>
                <div className="text-start">
                  <img src="images/features/a.png" alt="feature" className="pe-3 pe-md-7" />
                </div>
              </NioCard>
            </Col>
            <Col lg="6" >
              <NioCard className="border-0 h-100 bg-primary-soft">
                <NioCard.Body>
                  <div className="nl-feature-block-content">
                    <NioMedia size="lg" variant="red" rounded="circle" icon="files-fill"/>
                    <h4>Automate Your Sales on WhatsApp</h4>
                    <p className="fs-7 mb-0">ZiloChat takes care your entire sales process from product selections, upselling, shipping calculations, order confirmations, and entering it in your own crm.</p>
                    <NioButton href="" icon="arrow-right after" label="Learn More" className="btn-link mt-2 mt-md-5" />
                  </div>
                </NioCard.Body>
                <div className="text-end"  >
                  <img src="images/features/b.png" alt="feature" className="ps-3 ps-md-7" />
                </div>
              </NioCard>
            </Col>
            <Col md="6" xl="4" >
              <NioCard className="border-0 h-100 bg-primary-soft">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <NioMedia size="lg" variant="warning" rounded="circle" icon="user-switch-fill" />
                  <div>
                    <h4>Smart Suggestions for More Sales</h4>
                    <p className="fs-7">
                    Seamlessly suggest complementary products during chats to increase your average order value.
                    </p>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
            <Col md="6" xl="4" >
              <NioCard className="border-0 h-100 bg-primary-soft">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <NioMedia size="lg" variant="red" rounded="circle" icon="tree-structure-fill" />
                  <div>
                    <h4>Quick & Seamless Product Sharing</h4>
                    <p className="fs-7">Effortlessly share images and PDFs of your products directly with customers, helping them find what they need faster.</p>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
            <Col md="6" xl="4" >
              <NioCard className="border-0 h-100 bg-primary-soft">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <NioMedia size="lg" variant="primary" rounded="circle" icon="puzzle-fill"/>
                  <div>
                    <h4>Smart Product Recognition</h4>
                    <p className="fs-7">Just show ZiloChat the product, and its smart recognition instantly guides customers to the right choice.</p>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
            <Col md="6" xl="4" >
              <NioCard className="border-0 h-100 bg-primary-soft">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <NioMedia size="lg" variant="primary" rounded="circle" icon="puzzle-fill"/>
                  <div>
                    <h4>From AI to Human</h4>
                    <p className="fs-7">ZiloChat ensures a seamless transition to a live agent whenever you want to take control of the chat.</p>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
          </Row>
          <div className="text-center pt-7">
            <ul className="d-flex flex-wrap gap-3 gap-3 justify-content-center">
              <li>
                <NioButton href="/pricing" className="btn-primary" label="Get Started" />
              </li>
              {/* <li>
                <NioButton href="/features" className="btn-outline-primary" label="Explore All Features" />
              </li> */}
            </ul>
          </div>
        </NioSection.Content>
      </NioSection>
      {/*  Feature Section End  */}

      {/*  Feature Section Start  */}
      <NioSection className="nl-feature-section pb-7 pb-lg-120">
        <NioSection.Head alignX="center">
          <span className="nl-section-subtitle mb-2">Features</span>
          <h2 className="nl-section-title">All-in-One CRM for Complete Control</h2>
          {/* <p className="mb-0"> With cutting-edge tools for order management, inventory tracking, customer engagement, and more, ZiloChat is your all-in-one solution to boost efficiency and grow your business.          </p> */}
        </NioSection.Head>
        <NioSection.Content>
          <FeaturesContent />
        </NioSection.Content>
      </NioSection>
      {/*  Feature Section Start  */}

      {/*  Feature Section Start   */}
      {/* <NioSection className="py-7 pb-lg-120">
        <div className="nl-section-head pb-7">
          <Row className="align-items-end">
            <Col xl="6">
                <span className="nl-section-subtitle mb-2">WHY CUSE ZiloChat</span>
                <h2 className="nl-section-title mb-xl-0">See Your Business Like Never Before</h2>
            </Col>
            <Col xl="6">
              <p className="mb-0 text-start"> Powerful Insights at a Glance. </p>
            </Col>
          </Row>
        </div>
        <NioSection.Content>
          <Row className="gy-5 gy-lg-0">
            <Col md="6" lg="4" >
              <div className="position-relative">
                <div className="position-relative overflow-hidden rounded-4 border bg-gray">
                  <Link to="#">
                    <img src="images/blog/card-cover-6.png" alt="cover-img" className="img-fluid" />
                  </Link>
                </div>
                <div className="pt-4">
                  <h4>Dashboard</h4>
                </div>
              </div>
            </Col>
            <Col md="6" lg="4" >
              <div className="position-relative">
                <div className="position-relative overflow-hidden rounded-4 border bg-gray">
                  <Link to="#">
                    <img src="images/blog/card-cover-1.png" alt="" className="img-fluid" />
                  </Link>
                </div>
                <div className="pt-4">
                  <h4>Return Management</h4>
                </div>
              </div>
            </Col>
            <Col md="6" lg="4" >
              <div className="position-relative">
                <div className="position-relative overflow-hidden rounded-4 border bg-gray">
                  <Link to="#">
                    <img src="images/blog/card-cover-2.png" alt="card-cover" className="img-fluid" />
                  </Link>
                </div>
                <div className="pt-4">
                  <h4>Product Management</h4>
                </div>
              </div>
            </Col>
          </Row>
          
        </NioSection.Content>
        <div className="text-center pt-7">
            <ul className="d-flex flex-wrap gap-3 gap-3 justify-content-center">
              <li>
                <NioButton href="/pricing" className="btn-primary" label="Get Started" />
              </li>
              
            </ul>
          </div>
      </NioSection> */}
      {/*  Feature Section End   */}

      {/*  Testimonial Section Start  */}
      <NioSection className="nl-testimonial-section">
        <Row className="justify-content-center">
          <Col lg="8" xxl="4">
            <div className="nl-section-head text-center">
              <span className="nl-section-subtitle">Reviews</span>
              <h2 className="nl-section-title">What our customers are saying</h2>
            </div>
          </Col>
        </Row>
        <NioSection.Content>
          <Row className="g-3 g-lg-4">
            <Col lg="4">
              <NioCard className="h-100">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <div>
                    <ul className="d-flex gap-2 align-items-center mb-2">
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                    </ul>
                    <h5 className="mb-3">ZiloChat has streamlined our customer support.</h5>
                    <p className="fs-8 line-clamp-3">
                    We’ve been able to handle customer inquiries faster and more efficiently, directly through WhatsApp. The automation features have saved us so much time while improving response rates.
                    </p>
                  </div>
                  <div>
                    <h6 className="mb-0">Chamath Perera</h6>
                    <span className="small">3 months ago</span>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
            <Col lg="4">
              <NioCard className="h-100">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <div>
                    <ul className="d-flex gap-2 align-items-center mb-2">
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                    </ul>
                    <h5 className="mb-3">Great tool for growing businesses.</h5>
                    <p className="fs-8 line-clamp-3">
                    ZiloChat has made it easy to manage orders and customer interactions in one place. Improvement in reporting features, it’s been a great addition to our workflow.
                    </p>
                  </div>
                  <div>
                    <h6 className="mb-0">Nimali De Silva</h6>
                    <span className="small">3 months ago</span>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
            <Col lg="4">
              <NioCard className="h-100">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <div>
                    <ul className="d-flex gap-2 align-items-center mb-2">
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                    </ul>
                    <h5 className="mb-3">A fantastic solution for small businesses.</h5>
                    <p className="fs-8 line-clamp-3">
                    We’re a local business, and ZiloChat’s automation has helped us manage more leads without adding extra staff. It’s incredibly user-friendly and worth every rupee.
                    </p>
                  </div>
                  <div>
                    <h6 className="mb-0">Kasun Fernando</h6>
                    <span className="small">3 months ago</span>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
          </Row>
          <div className="text-center pt-5 pt-lg-7">
            <NioButton href="" className="btn-outline-primary" label="See All Reviews" />
          </div>
        </NioSection.Content>
      </NioSection>
      {/*  Testimonial Section End  */}

      {/*  Pricing Section Start  */}
      {/* <NioSection className="pt-120 pt-lg-160">
        <div>
          <NioSection.Head alignX="center">
            <span className="nl-section-subtitle mb-2" >pricing</span>
            <h2 className="nl-section-title">Simple Plans, Powerful Features</h2>
            <p className="mb-0" >Pick the plan that helps your business grow.</p>
           
          </NioSection.Head>
          <NioSection.Content>
            <Row className="gy-5">
              

              {plans.map((plan) => (
                <Col
                  md="6"
                  lg={{ span: 4, order: plan.id === 1 ? 2 : plan.id === 2 ? 1 : 3 }}
                  key={plan.id}
                >
                  <div
                    className={`nl-pricing nl-pricing-s3 mb-5 border p-5 h-100 ${
                      plan.id === 1 ? "active border-primary" : "border-lighter"
                    }`}
                  >
                    <div className="nl-pricing-head mb-3 mb-md-4">
                      <div className="nl-pricing-title-group mb-2">
                        <h4 className="mb-0">{plan.product_name}</h4>
                        {plan.id === 1 && (
                          <NioBadge
                            rounded
                            size="md"
                            label="Popular"
                            icon="star-fill"
                            className="text-bg-white text-primary"
                          />
                        )}
                      </div>
                      <p className="fs-6">{plan.description}</p>
                    </div>

                    <div className="nl-pricing-body">
                      <ul className="nl-list-link">
                        <li className={plan.des_1 ? "active" : ""}>
                          <NioIcon
                            name={`check-circle${plan.des_1 ? "-fill" : ""} me-1`}
                            className={plan.des_1 ? "text-primary" : ""}
                          />
                          <span className="fs-6">{plan.des_1 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_2 ? "active" : ""}>
                          <NioIcon
                            name={`check-circle${plan.des_2 ? "-fill" : ""} me-1`}
                            className={plan.des_2 ? "text-primary" : ""}
                          />
                          <span className="fs-6">{plan.des_2 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_3 ? "active" : ""}>
                          <NioIcon
                            name={`check-circle${plan.des_3 ? "-fill" : ""} me-1`}
                            className={plan.des_3 ? "text-primary" : ""}
                          />
                          <span className="fs-6">{plan.des_3 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_4 ? "active" : ""}>
                          <NioIcon
                            name={`check-circle${plan.des_4 ? "-fill" : ""} me-1`}
                            className={plan.des_4 ? "text-primary" : ""}
                          />
                          <span className="fs-6">{plan.des_4 || "Feature not available"}</span>
                        </li>
                      </ul>

                      <div className="nl-month-amount amount-wrap pt-4 mt-auto">
                        <span className="amount h3 mb-0">
                          {plan.currency_symbol}
                          {plan.selling_price} USD
                        </span>
                        <span className="amount-text opacity-75">/month</span>
                      </div>

                      <div className="pt-4">
                        <NioButton
                          href={`/auth/sign-up?referral=${plan.id}`}
                          className={`btn-block ${
                            plan.id === 2 ? "btn-primary" : "btn-outline-primary"
                          }`}
                          label={plan.id === 3 ? "Contact Sales" : "Get Started"}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </NioSection.Content>
        </div>
      </NioSection> */}
      {/*  Pricing Section Start  */}

      {/*  Process Section Start  */}
      <NioSection className="bg-primary-soft">
        <NioSection.Head alignX="center">
          <span className="nl-section-subtitle">Our Process</span>
          <h2 className="nl-section-title">How it works</h2>
          {/* <p> Our Three Step Process To Simplifying Your E-Commerce Journey. </p> */}
        </NioSection.Head>
        <NioSection.Content>
          <ul className="nl-timeline-group row gy-4 gy-lg-0 has-divider">
            <li className="nl-timeline-group-item col-xl-4" style={{width: '33%'}}>
              <div className="nl-timeline-group-content text-center">
                <NioMedia rounded="circle" size="lg" variant="indigo-700-soft" className="mb-3 mb-md-6 mx-auto fw-semibold">
                  <span className="h4 text-primary">1</span>
                </NioMedia>
                <div>
                  <span className="d-inline-block fs-8 mb-4 fw-semibold text-uppercase">step 1</span>
                  <h3 className="mb-2">Sign Up on Our Website</h3>
                  <p className="fs-6 line-clamp-3"> Share your business needs to get a tailored AI agent. </p>
                </div>
              </div>
            </li>
            <li className="nl-timeline-group-item col-xl-4" style={{width: '33%'}}>
              <div className="nl-timeline-group-content text-center">
                <NioMedia rounded="circle" size="lg" variant="indigo-700-soft" className="mb-3 mb-md-6 mx-auto fw-semibold">
                  <span className="h4 text-primary">2</span>
                </NioMedia>
                <div>
                  <span className="d-inline-block fs-8 mb-4 fw-semibold text-uppercase">Step 2</span>
                  <h3 className="mb-2">Create Your AI</h3>
                  <p className="fs-6 line-clamp-3">Our team builds your AI agent, fully customized and ready for initial review within just 5 days.</p>
                </div>
              </div>
            </li>
            <li className="nl-timeline-group-item col-xl-4" style={{width: '33%'}}>
              <div className="nl-timeline-group-content text-center">
                <NioMedia rounded="circle" size="lg" variant="indigo-700-soft" className="mb-3 mb-md-6 mx-auto fw-semibold">
                  <span className="h4 text-primary">3</span>
                </NioMedia>
                <div>
                  <span className="d-inline-block fs-8 mb-4 fw-semibold text-uppercase">step 3</span>
                  <h3 className="mb-2">Approve and Go Live</h3>
                  <p className="fs-6 line-clamp-3">Test your AI agent, make any necessary tweaks, and go live when you're ready to start transforming your business.</p>
                </div>
              </div>
            </li>
          </ul>
          <ul className="d-flex gap-3 flex-wrap align-items-center justify-content-center pt-5">
            <li>
              <NioButton href="/pricing" className="btn-primary" label="Get Started" />
            </li>
            
          </ul>
        </NioSection.Content>
      </NioSection>
      {/*  Process Section End  */}


      {/*  Trial Section Start  */}
      <NioSection className="bg-warning" style={{ backgroundColor: "#FDB52A" }}>
        <Row className="justify-content-center">
          <Col xl="10">
            <div className="nl-section-head text-center">
              <h2 className="display-3 mb-3" >Go From Chats to Checkout—Start Today!</h2>
              <div className="col-lg-7 mx-auto">
                <p className="fs-5 text-dark ">ZiloChat takes care of the work so you can scale faster, sell smarter, and focus on growing your business. Your next big win starts now.</p>
              </div>
            </div>
          </Col>
        </Row>
        <NioSection.Content>
          <Row className="justify-content-center">
            <Col md="10" lg="8" xl="6">
              <div>
              <div>
                <ul className="d-flex flex-wrap gap-3 gap-3 justify-content-center">
                  <li>
                    <NioButton href="/pricing" className="btn-primary" label="Get Started" />
                  </li>
                  {/* <li>
                    <NioButton href="/features" className="btn-outline-primary" label="Explore All Features" />
                  </li> */}
                </ul>
              </div>
                {/* <div>
                  <form onSubmit={e=>e.preventDefault()}>
                    <Row className="gy-3 gx-3">
                      <Col md="9">
                        <NioField.Input className="mb-4 mb-md-0" placeholder="Enter Your Email" />
                      </Col>
                      <Col md="3">
                        <input type="submit" className="btn btn-danger btn-block h-100" value="Sign Up Free" />
                      </Col>
                    </Row>
                  </form>
                </div> */}
                <ul className="d-flex flex-wrap align-items-center justify-content-around pt-5">
                  <li className="text-dark" >
                    <NioIcon name="check-circle" className="me-1" />
                    <span className="fs-6">24/7/365 Instant Response</span>
                  </li>
                  <li className="text-dark" >
                    <NioIcon name="check-circle" className="me-1" />
                    <span className="fs-6">All-in-One CRM Solution</span>
                  </li>
                  <li className="text-dark" >
                    <NioIcon name="check-circle" className="me-1" />
                    <span className="fs-6">Every Lead Matters</span>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </NioSection.Content>
      </NioSection>
      {/*  Trial Section End  */}

      {/*  NewsLetter Section Start   */}
      {/* <NioSection className="nl-section nl-section-nwsletter pb-0 pt-7 pt-lg-120">
        <Row className="justify-content-center justify-content-lg-between align-items-center gx-0 pb-5 border-bottom border-lighter">
          <Col lg="6" xl="4">
            <div className="text-center text-lg-start pb-5 pb-lg-0">
              <h4 className="text-capitalize">Subscribe to our newsletter</h4>
              <p className="fs-7">Join the 5000+ People That Uses Softnio Products.</p>
            </div>
          </Col>
          <Col md="10" lg="6" xl="5">
            <NioSubscribeField />
          </Col>
        </Row>
      </NioSection> */}
      {/*  NewsLetter Section End   */}

    </AppLayout>
  )
}

export default Index;